/**
 * Character-build feature: character sheet (P), inventory (I), skills & facets (K),
 * sigils / rune stone / gems (N), cards (L) and tempering (smith NPC), plus the shared
 * item/skill tooltip.
 */
import './build.css';
import type { Game } from '../../game/Game';
import { registerPanel } from '../../ui/app/App';
import { CardsPanel } from './CardsPanel';
import { CharacterPanel } from './CharacterPanel';
import { bindGame } from './common';
import { InventoryPanel } from './InventoryPanel';
import { SigilsPanel } from './SigilsPanel';
import { SkillsPanel } from './SkillsPanel';
import { TemperPanel } from './TemperPanel';

export { ItemTooltip, SkillTooltip, QualityBar, Money, tip, itemTip, skillTip, showTip, hideTip, itemIcon } from './Tooltip';
export type { ItemTooltipProps, SkillTooltipProps } from './Tooltip';
export { ItemCell, ItemIcon } from './common';
export { CardArt } from './CardsPanel';

export function install(game: Game): void {
  bindGame(game);
  registerPanel('character', CharacterPanel);
  registerPanel('inventory', InventoryPanel);
  registerPanel('skills', SkillsPanel);
  registerPanel('sigils', SigilsPanel);
  registerPanel('cards', CardsPanel);
  registerPanel('temper', TemperPanel);
}
